import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "../SEO";

// Shared light-weight header for the Games hub + each game page. Deliberately
// simpler than Academy.jsx's full hero: these are single-focus interactive
// pages, not article listings.
export default function GamesPageShell({ title, description, backTo = "/academy/games", backLabel = "Back to games", children }) {
  return (
    <div data-testid="games-page-shell" className="bg-[#FAFAFA] min-h-[80vh]">
      <SEO title={`${title}: ConfirmPH`} description={description} canonical={backTo === "/academy/games" ? "/academy/games" : undefined} />
      <div className="bg-[#0F1F18] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
          <Link to={backTo} data-testid="games-back-link"
                className="inline-flex items-center gap-1 text-emerald-300 text-xs hover:text-white min-h-11">
            <ArrowLeft className="w-3.5 h-3.5" /> {backLabel}
          </Link>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold mt-3">{title}</h1>
          {description && <p className="text-emerald-50/80 text-sm sm:text-base mt-2 max-w-2xl">{description}</p>}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {children}
      </div>
    </div>
  );
}
